import { useQuery } from '@tanstack/react-query';
import { useServices } from 'index';

export const useGetUserBillingInfo = () => {
  const bilingService = useServices().billingService;
  return useQuery({
    queryKey: ['userBillingInfo'],
    queryFn: () => bilingService.getBillingInfo(),
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });
};
